import PriceContainer from './PriceContainer';

export default PriceContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/Price/index.js